import React, { PureComponent } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';

import { getErrorMessage } from 'shared/lib/utils';
import * as api from '../../api/lead';

import { Select, Button, Input, TextArea } from 'shared/lib/SureDesignSystem';
import Footer from '../Footer';

import styles from './LandingLeadGen.module.css';

class LandingLeadGen extends PureComponent {
  constructor(props) {
    super(props);

    this.validationSchema = yup.object({
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      email: yup
        .string()
        .required('Email is required')
        .email('Invalid email address'),
      phoneNumber: yup
        .string()
        .required('Phone number is required')
        .matches(
          /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
          'Invalid phone number'
        ),
      companyName: yup.string().required('Company name is required'),
      comment: yup.string(),
    });

    this.initialFormValues = {
      comment: '',
    };

    this.state = {
      error: null,
      success: null,
    };
  }

  handleSubmit = values => {
    this.setState({
      error: null,
      success: null,
    });

    api
      .sendLeadEmail(values)
      .then(() => {
        this.setState({
          success: 'Thanks for submiting information',
        });
      })
      .catch(error => {
        this.setState({
          error: getErrorMessage(error),
        });
      });
  };

  render() {
    const { error, success } = this.state;

    return (
      <div className={styles.wrapper}>
        <div className={styles.leadGenSection}>
          <div className={styles.leadGenSection_container}>
            <h2 className={styles.leadGenSection_title}>
              We want to hear from you.
            </h2>
            <div className={styles.leadGenSection_content}>
              <div className={styles.leadGenSection_formWrapper}>
                <Formik
                  initialValues={this.initialFormValues}
                  validationSchema={this.validationSchema}
                  onSubmit={this.handleSubmit}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched,
                  }) => (
                    <form
                      autoComplete="off"
                      className={styles.leadGenSection_form}
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <Input
                        name="firstName"
                        label="First Name"
                        placeholder="What is your first name?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstName}
                        error={errors.firstName}
                        touched={touched.firstName}
                      />
                      <Input
                        name="lastName"
                        label="Last Name"
                        placeholder="What is your last name?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.lastName}
                        error={errors.lastName}
                        touched={touched.lastName}
                      />
                      <Input
                        name="email"
                        type="email"
                        label="Business Email"
                        placeholder="What is your business email?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        error={errors.email}
                        touched={touched.email}
                      />
                      <Input
                        name="jobTitle"
                        label="Job Title"
                        placeholder="What is your job title?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.jobTitle}
                        error={errors.jobTitle}
                        touched={touched.jobTitle}
                      />
                      <Select
                        name="companySize"
                        label="Company Size"
                        placeholder="What is your company size?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.companySize}
                        error={errors.companySize}
                        touched={touched.companySize}
                        options={[
                          {
                            value: '1-10',
                            label: '1-10',
                          },
                          {
                            value: '11-50',
                            label: '11-50',
                          },
                          {
                            value: '51-200',
                            label: '51-200',
                          },
                          {
                            value: '201-1000',
                            label: '201-1000',
                          },
                          {
                            value: '1000+',
                            label: '1000+',
                          },
                        ]}
                      />
                      <Input
                        name="phoneNumber"
                        label="Phone Number"
                        placeholder="What is your phone number?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phoneNumber}
                        error={errors.phoneNumber}
                        touched={touched.phoneNumber}
                      />
                      <Input
                        name="companyName"
                        label="Company Name"
                        placeholder="What is your company’s name?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.companyName}
                        error={errors.companyName}
                        touched={touched.companyName}
                      />
                      <Input
                        name="country"
                        label="Country"
                        placeholder="What country is your company in?"
                        showLabelAsterisk
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.country}
                        error={errors.country}
                        touched={touched.country}
                      />
                      <TextArea
                        name="comment"
                        label="How can we help you?"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.comment}
                        error={errors.comment}
                        touched={touched.comment}
                      />

                      {error && (
                        <p className={styles.leadGenSection_formError}>
                          {error}
                        </p>
                      )}
                      {success && (
                        <p className={styles.leadGenSection_formSuccess}>
                          {success}
                        </p>
                      )}

                      <Button type="submit">Submit</Button>
                    </form>
                  )}
                </Formik>
              </div>
              <div className={styles.leadGenSection_featuresWrapper}>
                <h3 className={styles.leadGenSection_featureTitle}>
                  Customer Support
                </h3>
                <p className={styles.leadGenSection_featureDescription}>
                  For any product or technical questions, reach us at{' '}
                  <a href="mailto:support@sureapp.com">support@sureapp.com</a>{' '}
                  or, checkout our{' '}
                  <a
                    href="https://support.sureapp.com/hc/en-us"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help Center
                  </a>
                  .{' '}
                </p>
                <p className={styles.leadGenSection_featureDescription}>
                  For Sales, Media & Press and General Inquiries, reach us at{' '}
                  <a href="mailto:contact@sureapp.com">contact@sureapp.com</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default LandingLeadGen;
